import "./global.css";
import "./styleguide.css";
import React from "react";
import ReactDOMClient from "react-dom/client";
import {BrowserRouter as Router} from 'react-router-dom';
import App from "./screens/JybeBusinessPage/App";
import ReactGA from 'react-ga4';

if (process.env.REACT_APP_API_URL == "https://api.jybe.ca") ReactGA.initialize('G-8LD765N85S');
const app = document.getElementById("root");
const root = ReactDOMClient.createRoot(app);

root.render(
    <React.StrictMode>
        <Router>
          <App/>
        </Router>
    </React.StrictMode>
  );
